import React, { useContext, useState } from 'react';
import { Layout } from 'antd';
import UserDetailContainer from './components/UserDetailContainer';
import SearchPane from './components/SearchPane/SearchPane';
import { SelectedUsersContext } from './context';
import styles from './UserPage.module.scss';

const { Sider, Content } = Layout;

const UserPage = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { selectedUsers } = useContext(SelectedUsersContext);
  return (
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    <Layout style={{ minHeight: '100vh' }}>
      <Sider
        breakpoint="lg"
        collapsed={collapsed}
        collapsedWidth="0"
        onCollapse={value => setCollapsed(value)}
        width={300}
      >
        <SearchPane />
      </Sider>
      <Content>
        <div className={styles.content}>
          <UserDetailContainer userIds={selectedUsers} />
        </div>
      </Content>
    </Layout>
  );
};

export default UserPage;
